/* eslint-disable camelcase, max-len, react/no-multi-comp, babel/no-invalid-this */
const iconsObj = {};

iconsObj.history = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
    </svg>
  );
};

iconsObj.view_column = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g>
        <path d="M11,18h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1v11C10,17.55,10.45,18,11,18z M5,18h3
          c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1H5C4.45,5,4,5.45,4,6v11C4,17.55,4.45,18,5,18z M16,6v11c0,0.55,0.45,1,1,1h3
          c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3C16.45,5,16,5.45,16,6z" />
      </g>
    </svg>
  );
};

iconsObj.view_module = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g>
        <path d="M5,11h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1H5C4.45,5,4,5.45,4,6v4C4,10.55,4.45,11,5,11z M5,18h3c0.55,0,1-0.45,1-1v-4
          c0-0.55-0.45-1-1-1H5c-0.55,0-1,0.45-1,1v4C4,17.55,4.45,18,5,18z M11,18h3c0.55,0,1-0.45,1-1v-4c0-0.55-0.45-1-1-1h-3
          c-0.55,0-1,0.45-1,1v4C10,17.55,10.45,18,11,18z M17,18h3c0.55,0,1-0.45,1-1v-4c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1v4
          C16,17.55,16.45,18,17,18z M11,11h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3c-0.55,0-1,0.45-1,1v4C10,10.55,10.45,11,11,11z
          M16,6v4c0,0.55,0.45,1,1,1h3c0.55,0,1-0.45,1-1V6c0-0.55-0.45-1-1-1h-3C16.45,5,16,5.45,16,6z" />
      </g>
    </svg>
  );
};

iconsObj.person = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g>
        <path d="M12,12c2.21,0,4-1.79,4-4s-1.79-4-4-4S8,5.79,8,8S9.79,12,12,12z M12,14c-2.67,0-8,1.34-8,4v1c0,0.55,0.45,1,1,1h14
          c0.55,0,1-0.45,1-1v-1C20,15.34,14.67,14,12,14z" />
      </g>
    </svg>
  );
};

iconsObj.person_outline = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M480 575q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42ZM160 896v-94q0-38 19-65t49-41q67-30 128.5-45T480 636q62 0 123 15.5t127.921 44.694q31.301 14.126 50.19 40.966Q800 764 800 802v94H160Zm60-60h520v-34q0-16-9.5-30.5T707 750q-64-31-117-42.5T480 696q-57 0-111 11.5T252 750q-14 7-23 21.5t-9 30.5v34Zm260-321q39 0 64.5-25.5T570 425q0-39-25.5-64.5T480 335q-39 0-64.5 25.5T390 425q0 39 25.5 64.5T480 515Zm0-90Zm0 411Z" />
    </svg>);
};

iconsObj.build = attrs => {
  return (
    <svg height="18" width="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect fill="none" height="18" width="18" />
      </g>
      <g>
        <g>
          <path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10 C22,6.48,17.52,2,12,2z M16.9,15.49l-1.4,1.4c-0.2,0.2-0.51,0.2-0.71,0l-3.41-3.41c-1.22,0.43-2.64,0.17-3.62-0.81 c-1.11-1.11-1.3-2.79-0.59-4.1l2.35,2.35l1.41-1.41L8.58,7.17c1.32-0.71,2.99-0.52,4.1,0.59c0.98,0.98,1.24,2.4,0.81,3.62 l3.41,3.41C17.09,14.98,17.09,15.3,16.9,15.49z" fillRule="evenodd" />
        </g>
      </g>
    </svg>
  );
};

iconsObj.people = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path fill="none" d="M0,0h24v24H0V0z" />
      </g>
      <g>
        <g>
          <path d="M16,11c1.66,0,2.99-1.34,2.99-3c0-1.66-1.33-3-2.99-3s-3,1.34-3,3C13,9.66,14.34,11,16,11z" />
          <path d="M8,11c1.66,0,2.99-1.34,2.99-3c0-1.66-1.33-3-2.99-3S5,6.34,5,8C5,9.66,6.34,11,8,11z" />
          <path d="M8,13c-2.33,0-7,1.17-7,3.5V18c0,0.55,0.45,1,1,1h12c0.55,0,1-0.45,1-1v-1.5C15,14.17,10.33,13,8,13z" />
          <path d="M16,13c-0.29,0-0.62,0.02-0.97,0.05c0.02,0.01,0.03,0.03,0.04,0.04C16.21,13.92,17,15.03,17,16.5V18
            c0,0.35-0.07,0.69-0.18,1H22c0.55,0,1-0.45,1-1v-1.5C23,14.17,18.33,13,16,13z" />
        </g>
      </g>
    </svg>
  );
};

iconsObj.group = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M38 896v-94q0-35 18-63.5t50-42.5q73-32 131.5-46T358 636q62 0 120 14t131 46q32 14 50.5 42.5T678 802v94H38Zm700 0v-94q0-63-32-103.5T622 633q69 8 130 23.5t99 35.5q33 19 52 47t19 63v94H738ZM358 575q-66 0-108-42t-42-108q0-66 42-108t108-42q66 0 108 42t42 108q0 66-42 108t-108 42Zm360-150q0 66-42 108t-108 42q-11 0-24.5-1.5T519 568q24-25 36.5-61.5T568 425q0-45-12.5-79.5T519 282q11-3 24.5-5t24.5-2q66 0 108 42t42 108ZM98 836h520v-34q0-16-9.5-31T585 750q-72-32-121-43t-106-11q-57 0-106.5 11T130 750q-14 6-23 21t-9 31v34Zm260-321q39 0 64.5-25.5T448 425q0-39-25.5-64.5T358 335q-39 0-64.5 25.5T268 425q0 39 25.5 64.5T358 515Zm0 321Zm0-411Z" />
    </svg>
  );
};

iconsObj.alarm = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none" /><path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" /></svg>
  );
};

iconsObj.minus = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect x="0" y="0" fill="none" width="24" height="24" />
      </g>
      <g>
        <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M16,13H8c-0.55,0-1-0.45-1-1v0
          c0-0.55,0.45-1,1-1h8c0.55,0,1,0.45,1,1v0C17,12.55,16.55,13,16,13z" />
      </g>
    </svg>
  );
};

// source: material.io/icons/
iconsObj.warning = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M4.47,21h15.06c1.54,0,2.5-1.67,1.73-3L13.73,4.99c-0.77-1.33-2.69-1.33-3.46,0L2.74,18C1.97,19.33,2.93,21,4.47,21z
          M12,14L12,14c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1h0c0.55,0,1,0.45,1,1v2C13,13.55,12.55,14,12,14z M13,18h-2v-2h2V18z" />
      </g>
    </svg>
  );
};

// source: material.io/icons/
iconsObj.launch = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19
        6.41V10h2V3h-7z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.undo = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08
        11.03 17.15 8 12.5 8z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.lock = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.unlock = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.send = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

iconsObj.send_outline = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M120 896V256l760 320-760 320Zm60-93 544-227-544-230v168l242 62-242 60v167Zm0 0V346v457Z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.refresh = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.save = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.inbox = attrs => {
  return (
    <svg width="18" height="18" fill="none" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0V0z" />
      <path d="M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.content_copy = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
    </svg>
  );
};

iconsObj.copy_content = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M180 975q-24 0-42-18t-18-42V312h60v603h474v60H180Zm120-120q-24 0-42-18t-18-42V235q0-24 18-42t42-18h440q24 0 42 18t18 42v560q0 24-18 42t-42 18H300Zm0-60h440V235H300v560Zm0 0V235v560Z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.chat = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.schedule = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
      <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.check = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.check_circle = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.check_box_outline_blank = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    </svg>
  );
};

iconsObj.check_box_checked = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="m419 735 289-289-43-43-246 246-119-119-43 43 162 162ZM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600V276H180v600Zm0-600v600-600Z" />
    </svg>);
};

// source: material.io/icons/
iconsObj.pin = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24" {...attrs}>
      <g><rect fill="none" height="24" width="24" /></g>
      <g>
        <path d="M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z" fillRule="evenodd" />
      </g>
    </svg>
  );
};

// source: material.io/icons/
iconsObj['cloud-upload'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.dashboard = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.highlight = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.add = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.delete = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

iconsObj.deleteX = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" {...attrs} viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.reorder = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-back'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-up'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-down'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
      <path d="M0-.75h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-left'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
      <path d="M0-.5h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-right'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
      <path d="M0-.25h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-firstpage'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
      <path d="M24 24H0V0h24v24z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['arrow-lastpage'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
      <path d="M0 0h24v24H0V0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.close = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.comment = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.edit = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['more-vert'] = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.unfold_more = attrs => {
  return (
    <svg width="22" height="22" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.unfold_less = attrs => {
  return (
    <svg width="22" height="22" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.favorite = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M16.5,3c-1.74,0-3.41,0.81-4.5,2.09C10.91,3.81,9.24,3,7.5,3C4.42,3,2,5.42,2,8.5c0,3.78,3.4,6.86,8.55,11.54L12,21.35
		    l1.45-1.32C18.6,15.36,22,12.28,22,8.5C22,5.42,19.58,3,16.5,3z M12.1,18.55l-0.1,0.1l-0.1-0.1C7.14,14.24,4,11.39,4,8.5
		    C4,6.5,5.5,5,7.5,5c1.54,0,3.04,0.99,3.57,2.36h1.87C13.46,5.99,14.96,5,16.5,5c2,0,3.5,1.5,3.5,3.5
		    C20,11.39,16.86,14.24,12.1,18.55z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.star = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /><path d="M0 0h24v24H0z" fill="none" /></svg>
  );
};

// source: material.io/icons/
iconsObj.star_border = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z" /><path d="M0 0h24v24H0z" fill="none" /></svg>
  );
};

// source: material.io/icons/
iconsObj.sentiment_satisfied = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z" /><circle cx="15.5" cy="9.5" r="1.5" /><circle cx="8.5" cy="9.5" r="1.5" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15.86.55 1.87.87 2.97.87 1.11 0 2.12-.33 2.98-.88-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z" /></svg>
  );
};

// source: material.io/icons/
iconsObj.sentiment_dissatisfied = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z" /><circle cx="15.5" cy="9.5" r="1.5" /><circle cx="8.5" cy="9.5" r="1.5" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14-.85-.56-1.87-.89-2.98-.89-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z" /></svg>
  );
};

// source: material.io/icons/
iconsObj.fullscreen = attrs => {
  return (
    <svg {...attrs} height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.photo = iconsObj.fullpage = attrs => {
  return (
    <svg height="18" viewBox="0 0 24 24" width="18" {...attrs} xmlns="http://www.w3.org/2000/svg">
      <path d="M24 24H0V0h24v24z" fill="none" />
      <path d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.detail = attrs => {
  return (
    <svg height="18" viewBox="0 0 24 24" width="18" {...attrs} xmlns="http://www.w3.org/2000/svg">
      <path d="M24 24H0V0h24v24z" fill="none" />
      <path d="M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.print = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.search = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.settings = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
    </svg>
  );
};

iconsObj.settings_outline = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="m388 976-20-126q-19-7-40-19t-37-25l-118 54-93-164 108-79q-2-9-2.5-20.5T185 576q0-9 .5-20.5T188 535L80 456l93-164 118 54q16-13 37-25t40-18l20-127h184l20 126q19 7 40.5 18.5T669 346l118-54 93 164-108 77q2 10 2.5 21.5t.5 21.5q0 10-.5 21t-2.5 21l108 78-93 164-118-54q-16 13-36.5 25.5T592 850l-20 126H388Zm92-270q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm0-60q-29 0-49.5-20.5T410 576q0-29 20.5-49.5T480 506q29 0 49.5 20.5T550 576q0 29-20.5 49.5T480 646Zm0-70Zm-44 340h88l14-112q33-8 62.5-25t53.5-41l106 46 40-72-94-69q4-17 6.5-33.5T715 576q0-17-2-33.5t-7-33.5l94-69-40-72-106 46q-23-26-52-43.5T538 348l-14-112h-88l-14 112q-34 7-63.5 24T306 414l-106-46-40 72 94 69q-4 17-6.5 33.5T245 576q0 17 2.5 33.5T254 643l-94 69 40 72 106-46q24 24 53.5 41t62.5 25l14 112Z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.menu = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...attrs} width="24" height="24" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.share = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.tick = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['track-changes'] = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...attrs} viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M18.32 5.68c-.36.36-.39.92-.07 1.32 1.45 1.82 2.21 4.31 1.53 6.92-.79 3.05-3.18 5.33-6.21 5.94C8.47 20.87 4 16.93 4 12c0-4.08 3.05-7.44 7-7.93v2.02c-3.13.53-5.43 3.46-4.93 6.83.39 2.61 2.56 4.71 5.18 5.03C14.89 18.4 18 15.56 18 12c0-1.25-.38-2.4-1.03-3.36-.34-.5-1.07-.53-1.5-.11l-.01.01c-.34.34-.37.87-.11 1.27.6.92.84 2.1.49 3.32-.39 1.37-1.54 2.46-2.94 2.77-2.6.57-4.9-1.39-4.9-3.9 0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2.71c0-.39-.32-.71-.71-.71-5.36-.2-9.98 4.06-10.27 9.4-.36 6.55 5.41 11.82 12.01 10.4 3.88-.83 6.88-3.8 7.75-7.67.71-3.16-.2-6.16-1.97-8.37-.37-.47-1.07-.5-1.49-.08z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.board = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.list = attrs => {
  return (
    <svg width="18" height="18" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.file = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.external = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['visibility-off'] = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none" />
      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj['visibility-on'] = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  );
};

// source: https://iconsvg.xyz/
iconsObj.saved_for_later = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...attrs} viewBox="0 0 24 24">
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.junk = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...attrs} width="24" height="24" viewBox="0 0 24 24">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.promoted = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...attrs} width="24" height="24" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.closing_x = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...attrs} width="24" height="24" viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.block = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.add_circle = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" {...attrs}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.beaker = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 24 24"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      {...attrs}>
      <rect fill="none" height="24" width="24" />
      <polygon opacity=".3" points="13,6 11,6 11,11.33 6,18 18,18 13,11.33" />
      <path d="M20.8,18.4L15,10.67V6.5l1.35-1.69C16.61,4.48,16.38,4,15.96,4H8.04C7.62,4,7.39,4.48,7.65,4.81L9,6.5v4.17L3.2,18.4 C2.71,19.06,3.18,20,4,20h16C20.82,20,21.29,19.06,20.8,18.4z M6,18l5-6.67V6h2v5.33L18,18H6z" />
    </svg>);
};

// source: material.io/icons/
iconsObj.pause = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      height="22"
      width="22"
      viewBox="0 0 24 24"
      {...attrs}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.play = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="black"
      width="22"
      height="22"
      {...attrs}>
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M8 5v14l11-7z" />
    </svg>
  );
};

// source: @jesse custom
iconsObj.expand = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <rect x="6.1" y="5" width="1" height="14" />
          <rect x="17.9" y="5" width="1" height="14" />
          <polygon points="8.1,11 8.1,13 11.1,13 11.1,17 17.1,12 11.1,7 11.1,11" />
        </g>
      </g>
    </svg>
  );
};

iconsObj.add_box = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M450 776h60V606h170v-60H510V376h-60v170H280v60h170v170ZM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600V276H180v600Zm0-600v600-600Z" />
    </svg>
  );
};

// source: @jesse custom
iconsObj.collapse = attrs => {
  return (
    <svg height="24" width="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M15.8,13v4l-6-5l6-5v4h3v2H15.8z" />
      </g>
      <g>
        <rect x="6.9" y="5" width="1" height="14" />
      </g>
    </svg>
  );
};

iconsObj['battlecard-single'] = attrs => {
  return (
    <svg {...attrs} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <rect width="300" height="300" fill="#fff" />
      <text style={{textAnchor: 'middle'}} x="150.59" y="235.191"><tspan x="150.59">Single page</tspan></text>
      <g fill="#34303b">
        <rect x="60" y="61" width="58" height="58" />
        <rect x="60" y="122" width="58" height="58" />
        <rect x="121" y="61" width="58" height="58" />
        <rect x="121" y="122" width="58" height="58" />
        <rect x="182" y="61" width="58" height="58" />
        <rect x="182" y="122" width="58" height="58" />
      </g>
      <rect fill="none" stroke="#34303b" strokeWidth="4" x="12" y="12" width="276" height="277" />
    </svg>
  );
};

iconsObj['battlecard-masonry'] = attrs => {
  return (
    <svg {...attrs} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <rect width="300" height="300" fill="#fff" />
      <text style={{textAnchor: 'middle'}} x="150.59" y="235.191"><tspan x="150.59">Masonry</tspan></text>
      <g fill="#34303b">
        <rect x="60" y="61" width="58" height="52" />
        <rect x="60" y="116" width="58" height="64" />
        <rect x="182" y="153" width="58" height="27" />
        <rect x="121" y="61" width="58" height="119" />
        <rect x="182" y="61" width="58" height="89" />
      </g>
      <rect fill="none" stroke="#34303b" strokeWidth="4" x="12" y="12" width="276" height="277" />
    </svg>
  );
};

iconsObj['battlecard-hero'] = attrs => {
  return (
    <svg {...attrs} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <rect width="300" height="300" fill="#fff" />
      <text style={{textAnchor: 'middle'}} x="150.59" y="235.191"><tspan x="150.59">Hero</tspan></text>
      <g fill="#34303b">
        <rect x="60" y="61" width="180" height="89" />
        <rect x="182" y="153" width="58" height="27" />
        <rect x="121" y="153" width="58" height="27" />
        <rect x="60" y="153" width="58" height="27" />
      </g>
      <rect fill="none" stroke="#34303b" strokeWidth="4" x="12" y="12" width="276" height="277" />
    </svg>
  );
};

iconsObj['battlecard-stacker'] = attrs => {
  return (
    <svg {...attrs} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <rect width="300" height="300" fill="#fff" />
      <text style={{textAnchor: 'middle'}} x="150.59" y="235.191"><tspan x="150.59">Stacker</tspan></text>
      <g fill="#34303b">
        <rect x="121" y="63" width="119" height="117" />
        <rect x="60" y="153" width="58" height="27" />
        <rect x="60" y="123" width="58" height="27" />
        <rect x="60" y="93" width="58" height="27" />
        <rect x="60" y="63" width="58" height="27" />
      </g>
      <rect fill="none" stroke="#34303b" strokeWidth="4" x="12" y="12" width="276" height="277" />
    </svg>
  );
};

// source: material.io/icons/
iconsObj.attachment = attrs => {
  return (
    <svg width="24" height="24" {...attrs} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z" /><path fill="none" d="M0 0h24v24H0V0z" />
    </svg>
  );
};

iconsObj.compareArrow = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...attrs} viewBox="0 0 24 24">
      <defs>
        <path id="a" d="M0 0h24v24H0V0z" />
      </defs>
      <clipPath id="b">
        <use overflow="visible" />
      </clipPath>
      <path d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z" />
    </svg>
  );
};

iconsObj.sortArrows = attrs => {
  const {fill = '#fff'} = attrs;

  return (
    <svg width="33px" height="34px" {...attrs} viewBox="0 0 33 34" xmlns="http://www.w3.org/2000/svg">
      <path fill={fill} d="M7,27.5007645 L7,3.5 L10,3.5 L10,27.5258895 L14.0312884,23.6348149 L16.1147383,25.7933414 L8.57986367,33.0661426 L0.778649431,25.8125968 L2.82144823,23.6155595 L7,27.5007645 Z M23,6.4992355 L23,30.5 L26,30.5 L26,6.47411048 L30.0312884,10.3651851 L32.1147383,8.20665863 L24.5798637,0.933857355 L16.7786494,8.18740318 L18.8214482,10.3844405 L23,6.4992355 Z" />
    </svg>
  );
};

iconsObj.thumb_up = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...attrs} viewBox="0 0 24 24"><path d="M24 24H0V0h24v24z" fill="none" /><path d="M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84C7 18.95 8.05 20 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z" /></svg>
  );
};

iconsObj.info = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" {...attrs}><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>
  );
};

iconsObj['info-outline'] = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" {...attrs}><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" /></svg>
  );
};

iconsObj.tag = attrs => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...attrs}>
      <path fill="none" d="M9.10536 17.7672C9.03287 17.8408 8.94652 17.8992 8.8513 17.9391C8.75608 17.9791 8.65389 17.9998 8.55062 18C8.44736 18.0002 8.34508 17.98 8.24969 17.9404C8.1543 17.9009 8.06771 17.8428 7.9949 17.7696L1.22745 11.0025C1.08132 10.8547 0.999559 10.6551 1 10.4473C1.00044 10.2395 1.08305 10.0403 1.22981 9.89307L10.1245 1H18V8.87415L9.10536 17.7672ZM4.61157 9.66157L9.3369 14.3861L4.61157 9.66157ZM6.97423 7.29932L11.6996 12.0238L6.97423 7.29932ZM13.2747 4.93708C13.2747 4.72824 13.3576 4.52796 13.5053 4.38029C13.653 4.23262 13.8534 4.14966 14.0622 4.14966C14.2711 4.14966 14.4714 4.23262 14.6191 4.38029C14.7668 4.52796 14.8498 4.72824 14.8498 4.93708C14.8498 5.14591 14.7668 5.34619 14.6191 5.49386C14.4714 5.64153 14.2711 5.72449 14.0622 5.72449C13.8534 5.72449 13.653 5.64153 13.5053 5.49386C13.3576 5.34619 13.2747 5.14591 13.2747 4.93708Z" stroke="#34ADE6" strokeWidth="2" />
    </svg>
  );
};

iconsObj.caution = attrs => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...attrs}>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.2084 9.50002C18.2084 14.3094 14.3095 18.2084 9.50008 18.2084C4.69071 18.2084 0.791748 14.3094 0.791748 9.50002C0.791748 4.69065 4.69071 0.791687 9.50008 0.791687C14.3095 0.791687 18.2084 4.69065 18.2084 9.50002ZM9.50008 16.625C10.4357 16.625 11.3623 16.4407 12.2267 16.0827C13.0911 15.7246 13.8766 15.1998 14.5382 14.5382C15.1998 13.8765 15.7247 13.0911 16.0827 12.2266C16.4408 11.3622 16.6251 10.4357 16.6251 9.50002C16.6251 8.56435 16.4408 7.63785 16.0827 6.7734C15.7247 5.90896 15.1998 5.1235 14.5382 4.46188C13.8766 3.80027 13.0911 3.27544 12.2267 2.91738C11.3623 2.55931 10.4357 2.37502 9.50008 2.37502C7.61041 2.37502 5.79814 3.12569 4.46195 4.46188C3.12575 5.79808 2.37508 7.61035 2.37508 9.50002C2.37508 11.3897 3.12575 13.202 4.46195 14.5382C5.79814 15.8744 7.61041 16.625 9.50008 16.625ZM10.2917 4.75002V11.0834H8.70841V4.75002H10.2917ZM10.2917 12.6667V14.25H8.70841V12.6667H10.2917Z" fill="#F2C94C" />
    </svg>
  );
};

iconsObj.link = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 48 48" {...attrs}><path d="M22.5 34H14q-4.25 0-7.125-2.875T4 24q0-4.25 2.875-7.125T14 14h8.5v3H14q-3 0-5 2t-2 5q0 3 2 5t5 2h8.5Zm-6.25-8.5v-3h15.5v3ZM25.5 34v-3H34q3 0 5-2t2-5q0-3-2-5t-5-2h-8.5v-3H34q4.25 0 7.125 2.875T44 24q0 4.25-2.875 7.125T34 34Z" /></svg>
  );
};

iconsObj.klueLink = attrs => {
  return (
    <svg width="1200" height="1200" viewBox="0 0 1200 1200" fill="none" xmlns="http://www.w3.org/2000/svg" {...attrs}>
      <path d="M488.051 244H392.004C387.031 244 383 248.029 383 253V946C383 950.971 387.031 955 392.004 955H488.051C493.024 955 497.056 950.971 497.056 946V253C497.056 248.029 493.024 244 488.051 244Z" fill="#011627" />
      <path d="M510.003 672.024C506.947 668.361 507.28 662.952 510.762 659.692L756.431 429.63C758.1 428.067 760.301 427.198 762.588 427.198H879.977C888.074 427.198 892.057 437.046 886.235 442.67L657.785 663.312C654.408 666.573 654.106 671.88 657.089 675.504L875.126 940.28C879.961 946.152 875.782 955 868.174 955H741.871C739.119 955 736.518 953.742 734.81 951.586L575.578 750.507C575.567 750.492 575.544 750.49 575.531 750.504C575.518 750.517 575.496 750.516 575.484 750.502L510.003 672.024Z" fill="#011627" />
    </svg>
  );
};

iconsObj.alert = attrs => {
  return (
    <svg aria-label="Alert" viewBox="0 0 24 24" className="StyledIcon-sc-ofa7kd-0 iJxtUR" {...attrs}>
      <path fill="none" strokeWidth="2" d="M12 17v2m0-9v6m0-13L2 22h20L12 3z" stroke="#FDB735" />
    </svg>
  );
};

iconsObj.event = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M566 976v-60h214V486H180v220h-60V296q0-24 18-42t42-18h65v-60h65v60h340v-60h65v60h65q24 0 42 18t18 42v620q0 24-18 42t-42 18H566Zm-246 66-42-42 113-114H50v-60h341L278 712l42-42 186 186-186 186ZM180 426h600V296H180v130Zm0 0V296v130Z" />
    </svg>
  );
};

iconsObj.toggle_off = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M280 816q-100 0-170-70T40 576q0-100 70-170t170-70h400q100 0 170 70t70 170q0 100-70 170t-170 70H280Zm0-60h400q75 0 127.5-52.5T860 576q0-75-52.5-127.5T680 396H280q-75 0-127.5 52.5T100 576q0 75 52.5 127.5T280 756Zm-1.059-79Q321 677 350.5 647.559t29.5-71.5Q380 534 350.559 504.5t-71.5-29.5Q237 475 207.5 504.441t-29.5 71.5Q178 618 207.441 647.5t71.5 29.5ZM480 576Z" />
    </svg>
  );
};

iconsObj.toggle_on = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M280 816q-100 0-170-70T40 576q0-100 70-170t170-70h400q100 0 170 70t70 170q0 100-70 170t-170 70H280Zm0-60h400q75 0 127.5-52.5T860 576q0-75-52.5-127.5T680 396H280q-75 0-127.5 52.5T100 576q0 75 52.5 127.5T280 756Zm400.941-79Q723 677 752.5 647.559t29.5-71.5Q782 534 752.559 504.5t-71.5-29.5Q639 475 609.5 504.441t-29.5 71.5Q580 618 609.441 647.5t71.5 29.5ZM480 576Z" />
    </svg>
  );
};

iconsObj.stop = attrs => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48" {...attrs}>
      <path d="M500 1056q-137 0-233.5-96.5T170 726V366q0-38 26.5-64t63.5-26q7 0 15 1.5t15 3.5v-35q0-38 26.5-64t63.5-26q8 0 16.5 1.5T413 162q11-29 34.5-47.5T500 96q35 0 62.5 25.5T590 182q5-2 13-4t17-2q38 0 64 26t26 64v164q8-2 16.5-3t13.5-1q38 0 64 26t26 64v210q0 137-96.5 233.5T500 1056Zm0-60q56 0 105.5-21t86-57.5q36.5-36.5 57.5-86T770 726V516q0-13-8.5-21.5T740 486q-12 0-21 8.5t-9 21.5v170l-13 2q-45 7-74.5 40T590 806h-60q3-56 35.5-100t84.5-66V266q0-13-8.5-21.5T620 236q-12 0-21 8.5t-9 21.5v260h-60V186q0-13-8.5-21.5T500 156q-12 0-21 8.5t-9 21.5v340h-60V246q0-13-8.5-21.5T380 216q-12 0-21 8.5t-9 21.5v320h-60V366q0-13-8.5-21.5T260 336q-12 0-21 8.5t-9 21.5v360q0 56 21 105.5t57.5 86q36.5 36.5 86 57.5T500 996Z" />
    </svg>
  );
};

const Icon = ({icon, ...attrs}) => {
  attrs.style = Object.assign({}, {
    fill: attrs.color || attrs.fill || 'currentColor',
    verticalAlign: 'middle'
  }, attrs.style);

  // Hide from screen readers.. coz thats what the cool kids do
  attrs['aria-hidden'] = 'true';

  if(iconsObj[icon]) {
    return iconsObj[icon].call(this, attrs);
  }
  else if(icon === 'kitchen-sink') {
    const icons = [];

    for(const i in iconsObj) {
      if(iconsObj.hasOwnProperty(i)) {
        icons.push(iconsObj[i].call(this, Object.assign(attrs, {key: i})));
      }
    }

    return (
      <div>{icons}</div>
    );
  }

  // output the list of icons to console
  console.log('Available icons:\n' + Object.keys(iconsObj).join('\n'));

  return (
    <span>?icon?</span>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

Icon.defaultProps = {
  icon: ''
};

export default Icon;
